<div class="w-full h-full flex flex-col gap-4">
    <div class="w-full flex items-center justify-between gap-2">
        <div class="flex items-center justify-center gap-2">
            <h2 class="oswald-font text-3xl text-nside-orange-400">
                Record of Changes
            </h2>
            <!-- <div data-popover-target="record-of-change-popover-right" data-popover-placement="right" type="button">
                <lucide-icon [name]="icons.CircleHelp" [size]=18 class="text-red-500"></lucide-icon>
            </div>
            <div data-popover id="record-of-change-popover-right" role="tooltip" class="absolute z-10 invisible inline-block max-w-96 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                <div class="px-3 py-2">
                    <p>
                        This is the Record of Changes section of the EOP. 
                    </p>
                </div>
                <div data-popper-arrow></div>
            </div> -->
        </div> 
        <div class="h-full relative">
            <!-- Button -->
            <button id="schoolYearDropdownButton" type="button"
                class="flex items-center justify-center gap-2 px-2 h-full rounded-md border border-gray-300 bg-gray-50 whitespace-nowrap"
                (click)="$event.preventDefault(); toggleSchoolYearDropdown()">
                {{ selectedSchoolYear }}
                <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 10 6">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 4 4 4-4" />
                </svg>
            </button>

            <!-- Dropdown list -->
            <div id="schoolYearDropdown" *ngIf="isSchoolYearDropdownOpen"
                class="absolute top-full mt-1 z-20 divide-y divide-gray-300 bg-orange-50 rounded-md w-full shadow-md">
                <ul class="py-2">
                    <li *ngFor="let year of schoolYears">
                        <a href="#" class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                            (click)="$event.preventDefault(); handleSchoolYearSelect(year);">
                            {{ year }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="w-full text-sm">
        <p>Each update or change to the plan should be tracked on this section.</p>
    </div>
    <ng-container *ngIf="recordOfChanges.length > 0; else emptyRecord">
        <div class="pb-2 w-full h-full flex flex-col items-center gap-2 overflow-x-auto overflow-y-auto">        
            <ol class="w-full overflow-y-auto relative border-s border-gray-200">
                <li *ngFor="let record of recordOfChanges | paginate: { itemsPerPage: itemsPerPage, currentPage: page };" class="mb-5 ms-4">
                    <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white"></div>
                    <p class="mb-1 text-sm font-normal leading-none text-gray-400">
                        {{ record.date | date: 'MM/dd/yyyy - HH:mm' }}
                    </p>
                    <h3 class="text-lg font-semibold text-gray-900">
                        {{ record.description }}
                    </h3>
                    <p class="mb-4 text-sm font-normal text-gray-500">
                        By {{ record.name }}
                    </p>
                </li>
            </ol>
        </div>
        <div class="flex justify-between items-center">
            <p>{{ recordOfChanges.length }} in total</p>
            <pagination-controls
                *ngIf="recordOfChanges.length > itemsPerPage" 
                (pageChange)="page = $event"
                previousLabel="Prev"
                nextLabel="Next"
                class="mt-2"
            ></pagination-controls>
        </div>
    </ng-container>
    <ng-template #emptyRecord>
        <div class="w-full text-nside-gray-100 italic">
            Empty Record
        </div>
    </ng-template>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>